import axios from "axios"

export const getStripePaymentLinks = async (accountId) => {
	return (await axios.get(`${process.env.REACT_APP_STRIPE_ENDPOINT}/get-product-payment-links/${accountId}`)).data
}